var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", class: _vm.containerClasses },
    [
      _c("StSidebar", {
        attrs: { temporary: false },
        on: { "sidebar-changed": _vm.sideBarChanged },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function () {
              return [
                _c(
                  "v-list",
                  { staticClass: "pt-0", attrs: { dense: "" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "access" } } },
                      [
                        _c(
                          "v-list-item",
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("StIcon", {
                                  attrs: { "icon-name": "login" },
                                }),
                              ],
                              1
                            ),
                            _c("v-list-item-title", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("LayoutContent.label.router.access")
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "router-link",
                      { attrs: { to: { name: "universes" } } },
                      [
                        _c(
                          "v-list-item",
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("StIcon", {
                                  attrs: {
                                    "icon-name": "view-dashboard-outline",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("v-list-item-title", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "LayoutContent.label.router.dashboard"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-row",
        { staticClass: "layout-content no-gutters" },
        [_c("transition", { attrs: { name: "fade" } }, [_c("router-view")], 1)],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }